import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Observable, EMPTY, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class VersionService implements OnDestroy {
    private _version: string;
    private _maintenance: boolean;
    private _initialized: boolean;
    private subs: Subscription[] = [];

    public get version(): string {
        return this._version;
    }
    public get isInMaintenance(): boolean {
        return this._maintenance;
    }
    constructor(private http: HttpClient) {
        this._version = '';
        this._maintenance = false;
        this._initialized = false;
        this.subs.push(this.http
            .get<any>(`./version.json?date=${new Date().toISOString()}`)
            .pipe(
                tap((appVersion) => {
                    this._version = appVersion.version;
                    this._maintenance = appVersion.maintenance;
                    this._initialized = true;
                    environment.kioskMode = (appVersion?.kioskMode ?? false);
                })
            )
            .subscribe());
    }

    public CheckVersion(): Observable<any> {
        return this.http.get<any>(`./version.json?date=${new Date().toISOString()}`).pipe(
            tap((appV) => {
                if (this._initialized === true && this._version !== '' && this._version !== appV.version) {
                    location.reload();
                }
                this._version = appV.version;
                this._maintenance = appV.maintenance;
                environment.kioskMode = (appV?.kioskMode ?? false);
            })
        );
    }
    
    ngOnDestroy(): void {
		this.subs.forEach((_) => _.unsubscribe());
	}
}
